import round from 'lodash/round';
import { useIntlV2 as useIntl } from '@atlassian/jira-intl/src/v2/use-intl.tsx';
import type { Count, ProdDataState } from '../../types';
import { getTrend } from '../../utils/trend';
import messages from './messages';

export const useDeploymentsComparisonMessageTranslated = (
	selectedWeekDeploymentProdCount: Count,
	averageDeploymentCountWholePeriod: Count,
	prodDataState: ProdDataState,
) => {
	const { formatMessage, formatNumber } = useIntl();

	if (prodDataState === 'COMPLETELY_EMPTY') {
		return formatMessage(messages.noDataFound);
	}

	if (prodDataState === 'INSUFFICIENT_FOR_TREND') {
		return formatMessage(messages.insufficientData);
	}

	if (prodDataState === 'NO_PROD_BUT_OTHER_ENV') {
		return formatMessage(messages.noProdButOtherEnv);
	}

	// SUFFICIENT_FOR_TREND
	const trend = getTrend(selectedWeekDeploymentProdCount, averageDeploymentCountWholePeriod);

	const numDeploymentsDiff = round(
		Math.abs(selectedWeekDeploymentProdCount - averageDeploymentCountWholePeriod),
		1,
	);

	if (trend === 'over') {
		return formatMessage(messages.deploymentsComparisonTextOver, {
			numDeploymentsDiff: formatNumber(numDeploymentsDiff),
		});
	}
	if (trend === 'under') {
		return formatMessage(messages.deploymentsComparisonTextUnder, {
			numDeploymentsDiff: formatNumber(numDeploymentsDiff),
		});
	}

	return formatMessage(messages.deploymentsComparisonTextEqual);
};

export const useIssuesComparisonMessageTranslated = (
	selectedWeekMedianIssuesProdCount: Count,
	medianIssuesCountWholePeriod: Count,
	prodDataState: ProdDataState,
) => {
	const { formatMessage, formatNumber } = useIntl();

	if (prodDataState === 'COMPLETELY_EMPTY') {
		return formatMessage(messages.noDataFound);
	}

	if (prodDataState === 'INSUFFICIENT_FOR_TREND') {
		return formatMessage(messages.insufficientData);
	}

	if (prodDataState === 'NO_PROD_BUT_OTHER_ENV') {
		return formatMessage(messages.noProdButOtherEnv);
	}

	// SUFFICIENT_FOR_TREND
	const trend = getTrend(selectedWeekMedianIssuesProdCount, medianIssuesCountWholePeriod);
	const numIssuesDiff = round(
		Math.abs(selectedWeekMedianIssuesProdCount - medianIssuesCountWholePeriod),
		1,
	);
	if (trend === 'over') {
		return formatMessage(messages.issuesComparisonTextOver, {
			numIssuesDiff: formatNumber(numIssuesDiff),
		});
	}
	if (trend === 'under') {
		return formatMessage(messages.issuesComparisonTextUnder, {
			numIssuesDiff: formatNumber(numIssuesDiff),
		});
	}

	return formatMessage(messages.issuesComparisonTextEqual);
};
